import { Helmet } from "react-helmet";
import { usePageSchema } from "../../hooks/usePageSchema";

/**
 * PageSchema Component
 * Automatically generates and injects JSON-LD schema for SEO
 *
 * Usage:
 * <PageSchema
 *   type="WebPage"
 *   title="Page Title"
 *   description="Page description"
 *   breadcrumbs={[{name: 'Home', url: 'https://primecloudsystems.com'}]}
 * />
 */
export default function PageSchema({
  type = "WebPage",
  title,
  description,
  image,
  breadcrumbs,
  product,
  categoryName,
  serviceType,
  faqs,
  url,
}) {
  const schemaJson = usePageSchema({
    type,
    title,
    description,
    image,
    breadcrumbs,
    product,
    categoryName,
    serviceType,
    faqs,
    url,
  });

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {url && <link rel="canonical" href={url} />}
      <script type="application/ld+json">{schemaJson}</script>
    </Helmet>
  );
}
